import api from "@/services/apiClient";

const V2 = "/api/v2";

export const listarPasarelas = (payload = {}) =>
  api.post(`${V2}/pasarelas/lista`, payload);

export const detallePasarela = (id) =>
  api.post(`${V2}/pasarelas/detalle`, { id });

export const guardarPasarela = (formData) =>
  api.post(`${V2}/pasarelas/guardar`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

export const editarPasarela = (formData) =>
  api.post(`${V2}/pasarelas/editar`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

export const eliminarPasarela = (id) =>
  api.post(`${V2}/pasarelas/eliminar`, { id });

export const syncProductosPasarela = (payload) =>
  api.post(`${V2}/pasarelas/sync-productos`, payload);

export const productosDisponibles = (tipster_id) =>
  api.post(`${V2}/pasarelas/productos-disponibles`, { tipster_id });

export const slugSugerido = (tipster_id) =>
  api.post(`${V2}/pasarelas/slug-sugerido`, { tipster_id });

export const obtenerPasarelaPublica = (slug) =>
  api.get(`${V2}/public/pasarelas/${slug}`);

export const listarPasarelasDelTipster = (tipsterId, productoId = 0) =>
  api.post(`${V2}/pasarelas/del-tipster`, { tipster_id: tipsterId, producto_id: productoId }, { _silent403: true });

export const syncPasarelasProducto = (productoId, pasarelaIds) =>
  api.post(`${V2}/pasarelas/sync-pasarelas-producto`, { producto_id: productoId, pasarela_ids: pasarelaIds });
